export const BUSINESS = {
  nameHi: "हनुमान प्रसाद बिहारीलाल",
  nameEn: "Hanuman Prasad Biharilal",
  tagHi: "थोक कपड़े के व्यापारी",
  tagEn: "Wholesale Cloth Merchants",
  addressHi: "HB भवन, बैंक रोड, सूतापट्टी, मुज़फ़्फ़रपुर, बिहार",
  addressEn: "HB Bhavan, Bank Road, Sutapatti, Muzaffarpur, Bihar",
  phones: ["2246684", "2245441", "9304012183", "9523594625"],
  email: "hb_mzp@yahoo.com",
  mapSrc:
    "https://www.google.com/maps?q=Bank+Road,+Sutapatti,+Muzaffarpur,+Bihar&output=embed",
};

export const translations = {
  en: {
    nav: { home: "Home", about: "About", fabrics: "Fabrics", contact: "Contact" },
    hero: {
      kicker: "Bank Road · Sutapatti · Muzaffarpur",
      line1: "Hanuman Prasad",
      line2: "Biharilal",
      sub: "Wholesale cloth merchants — dressing the shops of Bihar with cotton, silk and suiting, generation after generation.",
      cta1: "Explore Fabrics",
      cta2: "Visit the Shop",
      badge: "HB Group",
      since: "Trusted wholesale house",
    },
    marquee: ["Cotton", "Silk", "Suiting", "Shirting", "Poplin", "Uniform Cloth", "Dress Material", "Lining"],
    chapters: {
      kicker: "Our Story",
      title: "Woven into Muzaffarpur's bazaar",
      items: [
        {
          n: "01",
          title: "Heritage",
          text: "From the lanes of Sutapatti, our family has traded cloth the old way — by hand, by eye, and by word of honour.",
        },
        {
          n: "02",
          title: "Selection",
          text: "Bales and than after than of cotton, silk and suiting — hand-picked from mills we have known for decades.",
        },
        {
          n: "03",
          title: "Wholesale Trust",
          text: "Retailers across North Bihar buy from HB Bhavan because a rate quoted once is a rate honoured always.",
        },
      ],
    },
    gallery: {
      kicker: "The Collection",
      title: "Cloth for every counter",
      text: "A glimpse of the than, bales and rolls stacked inside HB Bhavan.",
      cta: "View full gallery",
    },
    cta: {
      title: "Buying for your shop?",
      text: "Walk into HB Bhavan on Bank Road, or call us — wholesale rates, honest measure.",
      btn: "Contact Us",
    },
    footer: {
      visit: "Visit Us",
      call: "Call Us",
      write: "Write to Us",
      links: "Pages",
      rights: "All rights reserved.",
      hours: "Mon – Sat · 10 AM – 8 PM",
    },
    about: {
      kicker: "About the House",
      title: "A name the bazaar trusts",
      intro:
        "Hanuman Prasad Biharilal is a wholesale cloth house at HB Bhavan, Bank Road, Sutapatti — in the beating heart of Muzaffarpur's cloth market.",
      chapters: [
        {
          n: "01",
          title: "Where it began",
          text: "The shop at HB Bhavan opened its shutters when Sutapatti was the cloth capital of North Bihar. Measuring by the yard, folding by hand — the rituals of the trade were learned early and never forgotten.",
          img: "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?auto=format&fit=crop&w=1200&q=80",
        },
        {
          n: "02",
          title: "The HB Group mark",
          text: "The rising sun in our mark is a promise — every bale that leaves HB Bhavan carries the family's name on it. Retailers from Sitamarhi to Samastipur stock our cloth.",
          img: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?auto=format&fit=crop&w=1200&q=80",
        },
        {
          n: "03",
          title: "Cloth, carefully chosen",
          text: "Cotton for the summer bazaar, silk for the wedding season, suiting and shirting for every tailor in town — each lot is felt, stretched and checked before it earns a place on our shelves.",
          img: "https://images.unsplash.com/photo-1445205170230-053b83016050?auto=format&fit=crop&w=1200&q=80",
        },
        {
          n: "04",
          title: "Wholesale, the honest way",
          text: "No retail counters, no fuss. We sell to shopkeepers and bulk buyers at rates that keep their business running — that is how relationships here have lasted decades.",
          img: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80",
        },
      ],
    },
    fabrics: {
      kicker: "Photo Gallery",
      title: "Inside the godown",
      text: "Cotton, silk, suiting and more — a walk through the shelves of HB Bhavan.",
      filters: { all: "All", cotton: "Cotton", silk: "Silk", suiting: "Suiting & Shirting", print: "Dress & Prints" },
    },
    contact: {
      kicker: "Contact",
      title: "Find us on Bank Road",
      text: "Call, write, or walk in — the shutters of HB Bhavan are up six days a week.",
      addressLabel: "Shop Address",
      phoneLabel: "Shop & Mobile",
      emailLabel: "Email",
      hoursLabel: "Shop Hours",
      hours: "Monday – Saturday · 10:00 AM – 8:00 PM · Sunday closed",
      mapLabel: "Reach HB Bhavan",
      callNow: "Call the Shop",
    },
  },
  hi: {
    nav: { home: "होम", about: "परिचय", fabrics: "कपड़े", contact: "संपर्क" },
    hero: {
      kicker: "बैंक रोड · सूतापट्टी · मुज़फ़्फ़रपुर",
      line1: "हनुमान प्रसाद",
      line2: "बिहारीलाल",
      sub: "थोक कपड़े के व्यापारी — पीढ़ी दर पीढ़ी, बिहार की दुकानों को सूती, रेशम और सूटिंग से सजाते हुए।",
      cta1: "कपड़े देखें",
      cta2: "दुकान पर आएँ",
      badge: "HB Group",
      since: "भरोसेमंद थोक भंडार",
    },
    marquee: ["सूती", "रेशम", "सूटिंग", "शर्टिंग", "पॉपलिन", "वर्दी कपड़ा", "ड्रेस मटेरियल", "अस्तर"],
    chapters: {
      kicker: "हमारी कहानी",
      title: "मुज़फ़्फ़रपुर के बाज़ार में बुना हुआ नाम",
      items: [
        {
          n: "01",
          title: "विरासत",
          text: "सूतापट्टी की गलियों से हमारा परिवार पुराने तरीके से कपड़े का व्यापार करता आया है — हाथ से, नज़र से और मुँह दिए शब्द के भरोसे से।",
        },
        {
          n: "02",
          title: "चुनाव",
          text: "सूती, रेशम और सूटिंग के थान पर थान — दशकों पुरानी मिलों से ख़ुद चुनकर लाए गए।",
        },
        {
          n: "03",
          title: "थोक का भरोसा",
          text: "पूरे उत्तर बिहार के दुकानदार HB भवन से कपड़ा लेते हैं, क्योंकि एक बार बोला गया भाव हमेशा निभाया जाता है।",
        },
      ],
    },
    gallery: {
      kicker: "हमारा संग्रह",
      title: "हर दुकान के लिए कपड़ा",
      text: "HB भवन के अंदर सजे थानों और गद्दियों की एक झलक।",
      cta: "पूरी गैलरी देखें",
    },
    cta: {
      title: "अपनी दुकान के लिए ख़रीदारी?",
      text: "बैंक रोड पर HB भवन आएँ या फ़ोन घुमाएँ — थोक भाव, सही नाप।",
      btn: "संपर्क करें",
    },
    footer: {
      visit: "पता",
      call: "फ़ोन",
      write: "ई-मेल",
      links: "पेज",
      rights: "सर्वाधिकार सुरक्षित।",
      hours: "सोम – शनि · सुबह 10 – रात 8",
    },
    about: {
      kicker: "परिचय",
      title: "वह नाम जिस पर बाज़ार को भरोसा है",
      intro:
        "हनुमान प्रसाद बिहारीलाल — HB भवन, बैंक रोड, सूतापट्टी स्थित थोक कपड़ा भंडार, मुज़फ़्फ़रपुर के कपड़ा बाज़ार के बीचों-बीच।",
      chapters: [
        {
          n: "01",
          title: "शुरुआत",
          text: "जब सूतापट्टी उत्तर बिहार का कपड़ा शहर था, तभी HB भवन के शटर खुले। गज़ से नापना, हाथ से मोड़ना — व्यापार की ये रीतियाँ आज भी ज़िंदा हैं।",
          img: "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?auto=format&fit=crop&w=1200&q=80",
        },
        {
          n: "02",
          title: "HB Group की छाप",
          text: "हमारी मुहर का उगता सूरज एक वादा है — HB भवन से निकली हर गद्दी पर परिवार का नाम होता है। सीतामढ़ी से समस्तीपुर तक दुकानदार हमारा कपड़ा बेचते हैं।",
          img: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?auto=format&fit=crop&w=1200&q=80",
        },
        {
          n: "03",
          title: "सोच-समझकर चुना कपड़ा",
          text: "गर्मी के बाज़ार के लिए सूती, शादी-ब्याह के मौसम के लिए रेशम, शहर के हर दर्ज़ी के लिए सूटिंग-शर्टिंग — हर लॉट छूकर, खीँचकर परखा जाता है।",
          img: "https://images.unsplash.com/photo-1445205170230-053b83016050?auto=format&fit=crop&w=1200&q=80",
        },
        {
          n: "04",
          title: "इमानदारी वाला थोक",
          text: "न छोटा-मोटा काउंटर, न कोई दिखावा। हम दुकानदारों और थोक ख़रीदारों को ऐसे भाव पर कपड़ा देते हैं कि उनका धंधा चलता रहे — यही वजह है कि रिश्ते दशकों से क़ायम हैं।",
          img: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80",
        },
      ],
    },
    fabrics: {
      kicker: "फ़ोटो गैलरी",
      title: "गोदाम के अंदर",
      text: "सूती, रेशम, सूटिंग और भी बहुत कुछ — HB भवन के अलमारियों की सैर।",
      filters: { all: "सभी", cotton: "सूती", silk: "रेशम", suiting: "सूटिंग-शर्टिंग", print: "ड्रेस व प्रिंट" },
    },
    contact: {
      kicker: "संपर्क",
      title: "बैंक रोड पर मिलिए",
      text: "फ़ोन कीजिए, चिट्ठी लिखिए या सीधे आइए — HB भवन के शटर हफ़्ते में छह दिन खुले रहते हैं।",
      addressLabel: "दुकान का पता",
      phoneLabel: "दुकान व मोबाइल",
      emailLabel: "ई-मेल",
      hoursLabel: "दुकान का समय",
      hours: "सोमवार – शनिवार · सुबह 10 – रात 8 · रविवार बंद",
      mapLabel: "HB भवन कैसे पहुँचें",
      callNow: "दुकान पर कॉल करें",
    },
  },
};

export const FABRICS = [
  {
    id: "silk-rose",
    cat: "silk",
    img: "https://images.pexels.com/photos/8793890/pexels-photo-8793890.jpeg?auto=compress&cs=tinysrgb&w=1200",
    nameEn: "Rose Silk", nameHi: "गुलाबी रेशम",
    descEn: "Soft wedding-season silk", descHi: "शादी-ब्याह का मुलायम रेशम",
  },
  {
    id: "cotton-bales",
    cat: "cotton",
    img: "https://images.unsplash.com/photo-1534639077088-d702bcf685e7?auto=format&fit=crop&w=1200&q=80",
    nameEn: "Cotton Than", nameHi: "सूती थान",
    descEn: "Mill-fresh white cotton rolls", descHi: "मिल-ताज़ा सफ़ेद सूती थान",
  },
  {
    id: "suiting-catalog",
    cat: "suiting",
    img: "https://images.unsplash.com/photo-1633655442330-0b44ca0cce9b?auto=format&fit=crop&w=1200&q=80",
    nameEn: "Suiting Lengths", nameHi: "सूटिंग पीस",
    descEn: "Checked suiting for tailors", descHi: "दर्ज़ियों के लिए चेक सूटिंग",
  },
  {
    id: "silk-stack",
    cat: "silk",
    img: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&w=1200&q=80",
    nameEn: "Silk Assortment", nameHi: "रेशमी संग्रह",
    descEn: "Colourful silk folds", descHi: "रंग-बिरंगे रेशमी कपड़े",
  },
  {
    id: "cotton-knit",
    cat: "cotton",
    img: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?auto=format&fit=crop&w=1200&q=80",
    nameEn: "Fine Knit Cotton", nameHi: "महीन सूती बुनाई",
    descEn: "Soft everyday weave", descHi: "रोज़ पहनने की नरम बुनाई",
  },
  {
    id: "shirting-rail",
    cat: "suiting",
    img: "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?auto=format&fit=crop&w=1200&q=80",
    nameEn: "Shirting Range", nameHi: "शर्टिंग रेंज",
    descEn: "Crisp shirting shades", descHi: "कुरकुरे शर्टिंग रंग",
  },
  {
    id: "print-rack",
    cat: "print",
    img: "https://images.unsplash.com/photo-1544441893-675973e31985?auto=format&fit=crop&w=1200&q=80",
    nameEn: "Dress Materials", nameHi: "ड्रेस मटेरियल",
    descEn: "Everyday prints and colours", descHi: "रोज़ाना के प्रिंट व रंग",
  },
  {
    id: "silk-white",
    cat: "silk",
    img: "https://images.unsplash.com/photo-1594734415578-00fc9540929b?auto=format&fit=crop&w=1200&q=80",
    nameEn: "Ivory Drape", nameHi: "हाथीदांत रेशम",
    descEn: "Premium ivory drape", descHi: "उत्तम हाथीदांत ड्रेप",
  },
  {
    id: "suit-formal",
    cat: "suiting",
    img: "https://images.unsplash.com/photo-1594938298603-c8148c4dae35?auto=format&fit=crop&w=1200&q=80",
    nameEn: "Formal Suiting", nameHi: "फ़ॉर्मल सूटिंग",
    descEn: "Coat & blazer lengths", descHi: "कोट व ब्लेज़र के पीस",
  },
  {
    id: "cotton-store",
    cat: "cotton",
    img: "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?auto=format&fit=crop&w=1200&q=80",
    nameEn: "Shelf Stock", nameHi: "अलमारी का स्टॉक",
    descEn: "Shelves stacked for retail buyers", descHi: "दुकानदारों के लिए सजे ढेर",
  },
  {
    id: "print-hang",
    cat: "print",
    img: "https://images.unsplash.com/photo-1445205170230-053b83016050?auto=format&fit=crop&w=1200&q=80",
    nameEn: "Hanging Prints", nameHi: "लटकते प्रिंट",
    descEn: "Season-ready printed lots", descHi: "मौसम के हिसाब से प्रिंटेड लॉट",
  },
  {
    id: "store-front",
    cat: "print",
    img: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80",
    nameEn: "Ready for Retail", nameHi: "दुकान के लिए तैयार",
    descEn: "Display-ready cloth lots", descHi: "डिस्प्ले के लिए तैयार लॉट",
  },
];

export const HERO_IMG =
  "https://images.unsplash.com/photo-1594734415578-00fc9540929b?auto=format&fit=crop&w=1400&q=80";
